import dayjs, { Dayjs } from 'dayjs';

export const getFirstAndLastDate = (date: Dayjs | string) => {
  const countDayjs = dayjs(date).daysInMonth();
  const firstDate = dayjs(date).date(1);
  const lastDate = dayjs(date).date(countDayjs);

  return { firstDate, lastDate };
};
